import { render, staticRenderFns } from "./IpsModal.vue?vue&type=template&id=7f78479d&scoped=true"
import script from "./IpsModal.vue?vue&type=script&lang=js"
export * from "./IpsModal.vue?vue&type=script&lang=js"
import style0 from "./IpsModal.vue?vue&type=style&index=0&id=7f78479d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78479d",
  null
  
)

export default component.exports